import { PostThumbProps } from "@/components/_blog-updates/PostThumb";
import PostThumbCarousel from "@/components/ArticleFooter/PostThumbCarousel";
import cn from "classnames";
import { FC } from "react";
import Grid from "../Grid";
import { Text } from "../Text";

export type RelatedContentCarouselProps = {
  title: string;
  items: PostThumbProps[];
  onAssetClick?: (mediaItemId: string) => void;
  className?: string;
}

export const RelatedContentCarousel: FC<RelatedContentCarouselProps> = ({ title, items, onAssetClick, className }) => {
  return (
    <div className={cn("w-full py-margin-section-md relative overflow-x-hidden", className)}>
      <Grid className="gap-y-spacing-48 md:gap-y-3xl">
        <Text type="h3" className="col-span-4 md:col-span-5">{title}</Text>
        <div className="col-span-4 md:col-span-12 w-full h-64">
          <PostThumbCarousel theme="light" items={items} onAssetClick={onAssetClick} />
        </div>
      </Grid>
    </div>
  );
};

export const UnpaddedRelatedContentCarousel: FC<RelatedContentCarouselProps> = ({ title, items, onAssetClick, className }) => {
  return (
    <div className={cn("w-full relative overflow-x-hidden", className)}>
      <Grid className="gap-y-spacing-48 md:gap-y-3xl">
        <Text type="h3" className="col-span-4 md:col-span-5">{title}</Text>
        <div className="col-span-4 md:col-span-12 w-full">
          <PostThumbCarousel theme="light" items={items} onAssetClick={onAssetClick} />
        </div>
      </Grid>
    </div>
  );
};
